module.exports = __webpack_public_path__ + "img/chargeback_ethoca.9cf7c7d0.png";